import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs';
import { Facet } from '../../models/facet-model';
import { SearchOutputModel } from '../../models/search-output-model';
import { SearchRequestModel } from '../../models/search-request-model';
import { SearchResultsModel } from '../../models/search-results-model';
import { ConstantsService } from '../../services/constants.service';
import { LoaderService } from '../../services/loader.service';
import { PubSearchService } from '../../services/pub-search.service';
import { QueryStateService } from '../../services/query-state.service';
import { MoreDetailsComponent } from '../more-details/more-details.component';
import { SortDetails } from '../../models/sort-details-model';
import { ShareViewComponent } from '../share-view/share-view.component';
import { AdamsDocModel } from '../../models/adams-doc-model';
import { ResultColumnsService } from '../../services/result-columns.service';
import { ReportsService } from '../../services/reports.service';
import { ResultSelectionService } from '../../services/result-selection.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-results-view',
  templateUrl: './results-view.component.html',
  styleUrls: ['./results-view.component.css']
})
export class ResultsViewComponent implements OnInit {

  facetsVisible: boolean = true;
  loading = false;
  searchQueryData: SearchRequestModel;
  searchOutput?: SearchOutputModel;
  searchResults: SearchResultsModel[] = []; //Complete list of results retrieved from the search
  viewItems: SearchResultsModel[] = []; // item shown on screen and in the table based on the page and pageSize
  facets?: Facet;

  totalCount: number = 0;
  qs?: string | null = '';
  routeLink: string = '';
  editSearchValues: any;
  currentView: string;
  pageSize: number = 25;
  first: number = 0;
  showSortReset: boolean = false;

  isDownloading = false;
  downloadOption = 'all';
  showDownloadOptions = false;
  reportType = '';
  isExcelDownload = false;
  progress: number = 0;
  cancelDownload = false;
  downloadFileType = 'CSV';
  selectedProps = [];

  tableCols: any[] = [];
  defaultTableColumns = ["DocumentTitle", "DateAddedTimestamp", "DateAdded", "DocumentDate"];

  showReportDialog: boolean = false;
  showDownloadDialog: boolean = false;
  showOverlay: boolean = true;

  // private downloadService: DownloadService,
  constructor(
    private searchSvc: PubSearchService,
    private actRouter: ActivatedRoute,
    private queryStateSvc: QueryStateService,
    private msgSvc: MessageService,
    private titleSvc: Title,
    private loaderService: LoaderService,
    private router: Router,
    private reportSvc: ReportsService,
    public dialogService: DialogService,
    public constants: ConstantsService,
    public columnsSvc: ResultColumnsService,
    public selectionSvc: ResultSelectionService
  ) {
    this.titleSvc.setTitle(environment.site_name + ' - Search Results');

    this.currentView = this.constants.results_view_table;
    this.searchQueryData = {
      q: '', indexId: 'EHD', size: this.pageSize, skip: 0, openProceedings: true, closedProceedings: true
    };

  }

  ngOnInit(): void {
    this.subscribeNavEvent();
    this.subscribeLoader();
    this.routeLink = window.location.href;
    this.searchQueryData = this.queryStateSvc.getSearchRequest();

    //    this.searchQueryData.q = this.queryStateSvc.getQueryString();

    this.tableCols = this.defaultTableColumns;

    this.initQueryCols();

    this.columnsSvc.parseSelectedCols(this.tableCols);

    this.initReportService();

    // Set a timeout for overlay after 1 seconds
    setTimeout(() => {
      this.showOverlay = false;
    }, 500);

    // Get Resolved Results
    this.actRouter.data.subscribe((d: any) => {
      this.searchOutput = d.results;
      this.qs = d.results.queryData;
      this.facets = d.results.facets;

      //Add the property used in Search
      this.addPropertySearchCol();

      this.loadData();
      this.queryStateSvc.setqData(this.queryStateSvc.getQueryView());
    });
  }

  initQueryCols() {
    //Adding Properties from Search
    let props = this.queryStateSvc.getSearchFilters();
    if (props && props.length > 0) {
      if (typeof (this.tableCols) == 'string') {
        this.tableCols = JSON.parse(this.tableCols);
      }
      // let mdItems = this.queryStateSvc.getMetadataProps();
      props.forEach((f) => {
        // Don't add if already there....
        if (this.tableCols.indexOf(f.field) == -1) {
          this.tableCols.push(f.field);
        }
      });
    }
  }

  initReportService() {
    this.reportSvc.cancelDownload$.subscribe(cd => { this.cancelDownload = cd; });
    this.reportSvc.isDownloading$.subscribe(d => { this.isDownloading = d; });
    this.reportSvc.downloadFileType$.subscribe(ft => { this.reportType = ft; });
    this.reportSvc.progress$.subscribe(p => { this.progress = p; });
  }

  addPropertySearchCol() {
    //Adding Properties from Search
    let props = this.queryStateSvc.getSearchFilters();
    if (props && props.length > 0) {
      if (typeof (this.tableCols) == 'string') {
        this.tableCols = JSON.parse(this.tableCols);
      }
      let mdItems = this.queryStateSvc.getMetadataProps();
      props.forEach((f) => {
        // Don't add if already there....
        if (this.tableCols.indexOf(f.field) == -1) {
          this.tableCols.push(f.field);
        }
      });
    }
  }

  subscribeLoader() {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }

  // clear facets when we navigate away from this page. Capture new NavStart Event
  subscribeNavEvent() {
    this.router.events.pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: any) => {
        // console.log("navstarted...");
        this.queryStateSvc.clearSelectedFacets();
      });
  }

  loadData() {
    if (this.searchOutput?.results) {
      this.searchResults = this.searchOutput?.results;
    }

    if (this.searchOutput?.count) {
      this.totalCount = this.searchOutput?.count;
      this.selectionSvc.setCount(this.totalCount);
    }

    this.updateView();
  }

  updateView() {
    this.viewItems = this.searchResults.slice(0, this.pageSize);
  }

  fetchData() {
    let sr = this.queryStateSvc.getUpdatedSearchRequest();
    sr.size = this.searchQueryData.size;
    sr.skip = this.searchQueryData.skip;

    // console.log('sr: ' + JSON.stringify(sr));

    this.searchSvc.getSearchResultsReq(sr).subscribe((data: any) => {
      if (data.results) {
        this.searchResults = data.results;
        this.facets = data.facets;
        this.updateView();
      }
    });
  }

  resetSort() {
    this.queryStateSvc.resetSort();
    this.showSortReset = false;
    this.applyUpdatedSort();
  }

  sortItems(sortDetails: SortDetails) {
    this.queryStateSvc.updateSelectedSort(sortDetails);
    this.showSortReset = true;
    this.applyUpdatedSort();
  }

  applyUpdatedSort() {
    let sr = this.queryStateSvc.getUpdatedSearchRequest();
    sr.skip = 0; // reset the pages to page 1 upon a new sort.
    this.first = 0; //Updated Paging.

    // console.log("Sort Query: " + JSON.stringify(sr));
    this.loading = true;
    this.searchSvc.getSearchResultsReq(sr).subscribe((sortedData: any) => {
      if (sortedData.results) {
        this.searchResults = sortedData.results;
        //this.facets = sortedData.facets;
        this.updateView();
        // console.log("updated view.");
      }
      this.loading = false;
    });
  }

  paginate(event: any) {
    this.pageSize = event.rows;
    this.searchQueryData.size = event.rows;
    // console.log('b4-first: '+ this.first);

    if (event.first > 100000) {
      this.first = 100000;
      this.searchQueryData.skip = 100000;
    }
    else {
      this.first = event.first;
      this.searchQueryData.skip = event.first;
    }
    // console.log('a-first: '+ this.first);

    this.fetchData();
    this.scrollToTop();
  }

  updateCols(items: any[]) {
    let temp: string[] = [];

    //Convert to String array after the items was updated from the table. 
    items.forEach((i: any) => {
      temp.push(i['field']);
    });

    this.tableCols = temp;
    this.columnsSvc.parseSelectedCols(this.tableCols);
  }

  showDocDetails(item: AdamsDocModel) {
    let itemType = 'Document';
    if (item.IsPackage == 'Yes') {
      itemType = 'Package';
    }

    const dialogRef = this.dialogService.open(MoreDetailsComponent, {
      data: item,
      closable: true,
      header: itemType + ' Item Properties',
      width: '75vw',
      contentStyle: { "max-height": "500px", "overflow": "auto" },
      baseZIndex: 10000
    });
  }

  showShareDialog(doc: AdamsDocModel) {
    const dialogRef = this.dialogService.open(ShareViewComponent, {
      data: doc,
      header: doc.AccessionNumber + ' - ' + doc.DocumentTitle,
      width: '50vw',
      contentStyle: { "max-height": "500px", "overflow": "auto" },
      baseZIndex: 10000
    });
  }

  applyFacets(updateOnly: boolean) {
    let sr = this.queryStateSvc.getUpdatedSearchRequest();
    sr.skip = 0; // reset the page number for paging.
    this.first = 0;
    this.searchSvc.getSearchResultsReq(sr).subscribe((r: any) => {
      if (r.results) {
        this.searchResults = r.results;

        if (r.facets)
          this.facets = r.facets;
        //Update Count in the page control.
        if (r.count) {
          this.totalCount = r.count;
          this.selectionSvc.setCount(this.totalCount);
        }


        if (!updateOnly) {
          this.msgSvc.add({ key: 'facetadded', severity: 'success', summary: 'Filter(s) Cleared' });
          this.first = 0; // Reset Page number after clearing the facets.
        }
        else {
          if (sr.filters) {
            if (sr.filters.length > 0) {
              this.msgSvc.add({ key: 'facetadded', severity: 'success', summary: 'Filter(s) applied', detail: this.queryStateSvc.displayFilters(sr.filters) });
            }
            else {
              this.msgSvc.add({ key: 'facetadded', severity: 'success', summary: 'Filter(s) Cleared' });
              this.first = 0; // Reset Page number after clearing the facets.
            }
          }
        }
        this.selectionSvc.clearAll();
        this.updateView();
      }
      else {
        this.msgSvc.add({ key: 'facetadded', severity: 'danger', summary: 'No new results to update' })
        // console.log("no results updated: " + JSON.stringify(r));
      }

    });
  }

  toggleView(newView: string) {
    this.currentView = newView;
  }

  toggleFacets(visible: boolean) {
    this.facetsVisible = visible;
  }
  showCreateReport() {
    this.showReportDialog = true;
  }

  hideReports() {
    this.showReportDialog = false;
  }

  showDownloadDocs() {
    this.showDownloadDialog = true;
  }
  hideDownloadDocs() {
    this.showDownloadDialog = false;
  }

  // Reports Download
  downloadSelected(options: any) {
    this.reportSvc.setFileType(options['fileType']);
    this.reportSvc.downloadOption = options['downloadType'];
    this.reportSvc.selectedProps = options['props'];
    this.reportSvc.setTotalCount(this.totalCount);

    this.showReportDialog = false;
    this.reportSvc.startDownload();
  }

  executeCancelDownload() {
    this.reportSvc.setCancelDownload(true);
  }

  scrollToTop() {
    const tableElement = document.querySelector('#results-top');
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: 'auto' });
    }
  }
}
